const ApplicationConst = {
    SWITCH_SIDEBAR_HEADER: "SWITCH_SIDEBAR_HEADER",
    SWITCH_SIDEBAR_SUB: "SWITCH_SIDEBAR_SUB",
    AJAX_CALL: "AJAX_CALL",
    AJAX_CALL_FINISHED: "AJAX_CALL_FINISHED",
    AJAX_ERROR: "AJAX_ERROR",
    SET_NAMESPACE: "SET_NAMESPACE",
    SET_PARENT: "SET_PARENT",
    SET_CONTEXT: "SET_CONTEXT",
    MODAL_OPEN: "MODAL_OPEN",
    MODAL_CLOSE: "MODAL_CLOSE",
    WINDOW_RESIZE: "WINDOW_RESIZE",
    GET_LANGUAGE_PACKAGE: "GET_LANGUAGE_PACKAGE",
    SWITCH_LANGUAGE: "SWITCH_LANGUAGE",
    SET_TOKEN: "SET_TOKEN"
};

export default ApplicationConst;



// WEBPACK FOOTER //
// ./src/ApplicationConst.js